const openNewsletterModal = () => {
  const modal = document.querySelector(".newsletter-modal");
  const openBtns = document.querySelectorAll(".open-newsletter-modal");
  const closeBtns = modal.querySelectorAll(".close-newsletter, .close-modal");

  if (!modal || openBtns.length === 0) return;

  // Open modal
  openBtns.forEach((btn) =>
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.add("show");
      // Optionally trap focus here
    })
  );

  // Close modal handlers
  const closeModal = () => {
    modal.classList.remove("show");
  };

  closeBtns.forEach((btn) =>
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      closeModal();
    })
  );

  // Close on backdrop click
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("show")) {
      closeModal();
    }
  });
};

export default openNewsletterModal;
